export const setVehicleDepartment = (data) => {
  return {
    type: "VEHICLEDEPARTMENT",
    payload: data,
  };
};
